import { IconButton, SxProps, Theme, Tooltip, TooltipProps } from '@mui/material';
import { ReactNode } from 'react';
import { ICONS } from '@/assets/icons';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import Iconify from '@/components/Iconify';

interface Props {
  text: ReactNode;
  maxwidth?: number;
  sx?: SxProps<Theme>;
  placement?: TooltipProps['placement'];
  textColor?: string;
  iconStyle?: 'outlined' | 'contained';
}

const InfoTooltip = ({
  text,
  maxwidth = 500,
  sx,
  placement = 'bottom-start',
  textColor = 'text.primary',
  iconStyle = 'outlined',
}: Props) => {
  return (
    <Tooltip
      title={
        <PTypography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
          {text}
        </PTypography>
      }
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper',
            color: textColor,
            py: 1,
            px: 2,
            maxWidth: maxwidth,
            zIndex: 0, // Fix Safari overflow: hidden with border radius
          },
        },
      }}
      placement={placement}
    >
      <IconButton disableRipple sx={{ cursor: 'default', ...sx }}>
        <Iconify icon={iconStyle === 'outlined' ? ICONS.INFO : ICONS.INFO_CONTAINED} width={20} height={20} />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
